/**
 * Stored report runs (migrations 0071 + 0072) — a generated PDF/XLSX kept so it
 * can be re-opened later and on mobile. List the history, upload a freshly
 * exported artifact, and download the bytes. The artifact lives inline in
 * Postgres server-side (no object store), so download streams the authenticated
 * bytes straight from the API. Mirrors internal/twin/report_runs.go.
 */

import { api } from "@/lib/api-client";
import { qs } from "./qs";
import type { Paginated } from "./types";

/** One stored report artifact. Mirrors twin.ReportRun. */
export interface ReportRun {
  id: string;
  report_id?: string | null;
  title: string;
  kind: string;
  granularity: string;
  date_from?: string | null;
  date_to?: string | null;
  format: string;
  file_size: number;
  generated_at: string;
}

/** A freshly-exported artifact to store + its metadata. */
export interface ReportRunUpload {
  blob: Blob;
  filename: string;
  title: string;
  format: "pdf" | "xlsx" | "csv" | "html";
  kind?: string;
  granularity?: string;
  date_from?: string;
  date_to?: string;
  report_id?: string;
}

export const reportRuns = {
  /** The org's stored runs, newest first. `GET /v1/twin/report-runs`. */
  list: (params?: { limit?: number; offset?: number }) =>
    api.get<Paginated<ReportRun>>(`/v1/twin/report-runs${qs(params ?? {})}`),
  /** Upload a generated artifact. `POST /v1/twin/report-runs` (multipart) → 201. */
  create: (u: ReportRunUpload) => {
    const fd = new FormData();
    fd.append("file", u.blob, u.filename);
    fd.append("title", u.title);
    fd.append("format", u.format);
    if (u.kind) fd.append("kind", u.kind);
    if (u.granularity) fd.append("granularity", u.granularity);
    if (u.date_from) fd.append("date_from", u.date_from);
    if (u.date_to) fd.append("date_to", u.date_to);
    if (u.report_id) fd.append("report_id", u.report_id);
    return api.postForm<ReportRun>("/v1/twin/report-runs", fd);
  },
  /** Download the stored artifact bytes. `GET …/{id}/download` → Blob. */
  download: (id: string) => api.getBlob(`/v1/twin/report-runs/${id}/download`),
};
